/**
 * i18n/index.ts — i18next 초기화 (side-effect import).
 *
 * 【역할】
 * - i18next 싱글톤 생성 + react-i18next 플러그인 등록.
 * - 5 locale (ko/en/zh/ja/vi) resources 껍데기(empty translation) 사전 등록 — 런타임에
 *   `/api/labels?locale=xx` 응답을 `i18n.addResourceBundle()` 로 주입.
 * - 초기 lng 는 localStorage(fw.locale) 우선, 없으면 'ko' fallback.
 *
 * 【주요 기능】
 * - escapeValue:false — React 가 자동 escape 하므로 i18next 중복 escape 방지.
 * - returnNull:false — 누락 키 반환값을 null 대신 빈 문자열로 (렌더 시 undefined 방지).
 * - fallbackLng:'ko' — locale 별 번들에 키 없으면 ko 로 fallback.
 *
 * 【사용 위치】 main.tsx 에서 `import '@/i18n'` 로 1회 side-effect 실행.
 *
 * 【포팅 원본】 Spring 프런트 `i18n.ts` (동일 5 locale 구조).
 *
 * 【의존성】 i18next / react-i18next.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const savedLocale = typeof window !== 'undefined' ? localStorage.getItem('fw.locale') : null

void i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: {} },
    en: { translation: {} },
    zh: { translation: {} },
    ja: { translation: {} },
    vi: { translation: {} }
  },
  lng: savedLocale ?? 'ko',
  fallbackLng: 'ko',
  interpolation: { escapeValue: false },
  returnNull: false
})

export default i18n
